import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import '@maersk-global/mds-components-core/mc-drawer';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-file-upload';
import '@maersk-global/mds-components-core/mc-button';

import { Shop } from '../../../models/shop.model';

const ALLOWED_FILE_EXTENSION = 'xlsx';

@Component({
  selector: 'app-vessel-wo-upload-drawer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './vessel-wo-upload-drawer.component.html',
  styleUrl: './vessel-wo-upload-drawer.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VesselWoUploadDrawerComponent {
  @Input() open = false;
  @Input() vesselShops: Shop[] = [];
  @Input() isSubmitting = false;

  @Output() saved = new EventEmitter<{ maintenanceShopCode: string; file: File }>();
  @Output() cancelled = new EventEmitter<void>();

  readonly maintenanceShopCodeControl = new FormControl<string>('', Validators.required);
  selectedFile: File | undefined;
  uploadErrorMessage: string | undefined;

  onShopSelected(event: Event): void {
    const detail = (event as CustomEvent).detail;
    const value = typeof detail === 'string' ? detail : detail?.value;
    this.maintenanceShopCodeControl.setValue(value ?? '');
    this.maintenanceShopCodeControl.markAsTouched();
  }

  onFileChange(event: Event): void {
    this.uploadErrorMessage = undefined;
    const file: File | undefined = (event as CustomEvent).detail?.[0];

    if (!file) {
      this.selectedFile = undefined;
      return;
    }

    const extension = file.name.split('.').pop()?.toLowerCase();
    if (extension !== ALLOWED_FILE_EXTENSION) {
      this.uploadErrorMessage = 'Only .xlsx files are allowed.';
      this.selectedFile = undefined;
      return;
    }

    this.selectedFile = file;
  }

  onCloseDrawer(event: Event): void {
    const action = (event as CustomEvent<{ action: string }>).detail?.action;
    if (action !== 'ok') {
      this.cancelled.emit();
    }
  }

  onSubmit(): void {
    this.maintenanceShopCodeControl.markAsTouched();
    if (!this.canSubmit) {
      return;
    }

    this.saved.emit({
      maintenanceShopCode: this.maintenanceShopCodeControl.value!,
      file: this.selectedFile!,
    });
  }

  get canSubmit(): boolean {
    return !!this.selectedFile && this.maintenanceShopCodeControl.valid && !this.isSubmitting;
  }
}
